import { cn } from "@volca/ui/lib/utils";

interface LoadingCountProps {
  className?: string;
  count?: number;
  isCountLoading?: boolean;
  variant?: "default" | "subtle";
  size?: "default" | "small";
  showParentheses?: boolean;
}

export const LoadingCount = ({
  className,
  count,
  isCountLoading,
  variant = "default",
  size = "default",
  showParentheses = false,
}: LoadingCountProps) => {
  if (isCountLoading) {
    return (
      <span
        className={cn(
          "inline-flex items-center gap-1 font-normal",
          variant === "default" ? "text-subtle" : "text-subtle",
          !showParentheses && "ml-1",
          className,
        )}
      >
        {showParentheses && "("}
        {/* The preset's Skeleton is a div, which can't sit in this span. */}
        <span
          data-slot="skeleton"
          className={cn(
            "inline-block h-2 w-6 animate-pulse rounded-md bg-neutral",
            size === "small" && "h-1 w-4",
          )}
        />
        {showParentheses && ")"}
      </span>
    );
  }

  if (count === undefined || count === null) return null;

  return (
    <span
      className={cn(
        "font-normal",
        variant === "default" ? "text-subtle" : "text-subtle",
        className,
      )}
    >
      ({count})
    </span>
  );
};
